import { render, staticRenderFns } from "./GroupFormSidebar.vue?vue&type=template&id=274cec06"
import script from "./GroupFormSidebar.vue?vue&type=script&lang=js"
export * from "./GroupFormSidebar.vue?vue&type=script&lang=js"
import style0 from "./GroupFormSidebar.vue?vue&type=style&index=0&id=274cec06&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports